import { Skeleton } from "antd";
import { withRouter } from "react-router-dom";
import React, {useEffect} from "react";
import { connect } from "react-redux";
import "./jobs-applied.scss";
import { pushLog2DV2LogServer } from '../../../../services/logging';
import jwt from 'jsonwebtoken';
import { Alert } from 'antd';
import { COMPARE_STATUS, STATUS } from "../../../constants/status";
import JobsPortal from "../../jobsPortal";
import ProfileActions from "../../../../../dv2_temporary_solution/UI_V2_Components/profile/Profile.actions";
import useFlagsFromBackend, { GB_FLAGS } from "../../../services/launchDarkly";

export const logJobDashboardActivity = (category,activity,payload)=>{
  const token = localStorage.getItem('token');
  const user = jwt.decode(token);
  pushLog2DV2LogServer.info(
    category,
    activity,
    { user_id: user.uid},
    { user_id: user.uid, timestamp: new Date(),...payload },
    );
}

const JobsPage = ({ jobsAppliedLoading = false, jobsV2Loading = false, loading = false, jobsV2, jobsV2Count = 0, jobs_applied, devStatus, dispatch }) => {
  const { $flagsReady, use_application_tracking_ui: useApplicationTrackingUI } =
    useFlagsFromBackend([GB_FLAGS.use_application_tracking_ui]);
  const showLoader = loading || jobsAppliedLoading || jobsV2Loading || !$flagsReady;
  
  useEffect(() => {
    const {
      active = [],
      inactive = [] 
    } = jobs_applied || {};
    logJobDashboardActivity('JOB_APPLICATIONS','PAGE_VIEWED',{ 
      active_jobs: active.length || 0, 
      inactive_jobs: inactive.length || 0, 
      recommended_jobs: jobsV2Count,
      jobs: jobsV2,
      referrer: window.frames.top.document.referrer
    })
  }, [jobs_applied, jobsV2]);
  const isP3Dev = COMPARE_STATUS(devStatus, STATUS.IN_TRIAL) >= 0 && (devStatus || '').toLowerCase() !== STATUS.FIRED.toLowerCase();
  const isFiredDev = (devStatus || '').toLowerCase() === STATUS.FIRED.toLowerCase();

  useEffect(() => {
    dispatch(ProfileActions.LOAD_PROFILE_DATA)
  }, [])

  const renderAlerts = () => {
    return (
      <>
        {isP3Dev && (
          <Alert
            message="Unable to apply to jobs!"
            description="You are already in an active engagement with a Turing client, hence you cannot apply to jobs."
            type="warning"
            closable={false}
          />
        )}
        {isFiredDev && (
          <Alert
            message="Unable to apply to jobs!"
            description="You are not eligible to apply for new jobs."
            type="warning"
            closable={false}
          />
        )}
      </>
    )
  }

  return (
    <Skeleton loading={showLoader} active={showLoader}>
      {renderAlerts()}
      <JobsPortal useApplicationTrackingUI={useApplicationTrackingUI} />
    </Skeleton>
  );
};

const mapStateToProps = ( state ) => {
  const {
    jobs: { jobsAppliedLoading = false, jobsV2Loading = false, loading = false, jobsV2 = [], fastrack = [],jobs_applied } = {},
    home: { devStatus = "" } = {}
  } = state;
  const jobsV2Count = (jobsV2.length || 0) + (fastrack.length || 0);
  return {
    jobsAppliedLoading,
    jobsV2Loading,
    loading,
    jobsV2Count,
    jobs_applied,
    jobsV2,
    devStatus
  };
};

export default connect(mapStateToProps)(withRouter(JobsPage));